// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***********************
* GLOBAL COLOR TOKENS * 
***********************/
.Ide-module__ideWrapper--fABC6 {
  /* Eat the remaining space on the page. */
  min-width: 0;
  width: 100%;
  height: 100vh;
  position: relative;
  isolation: isolate;
}

.Ide-module__resizeHandle--lbGjf {
  z-index: 1;
  height: var(--console-log-resize-bar-height);
  width: 100%;
  background-color: #e4e4e7;
}

/**
 * Header and tabs
 */
.Ide-module__editorWrapper--Eyeab {
  height: 100%;
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
}

.Ide-module__editorHeader--Xu8mW {
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  scrollbar-width: 0;
  display: flex;
  align-items: center;
  height: var(--editor-header-height);
  gap: 0.125rem;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  background-color: var(--tab-button-primary-color);
  padding-right: 0.5rem;
}

.Ide-module__icon--odAa6 {
  height: 1.25rem;
}

button.Ide-module__showMenuButton--bDW0p {
  display: flex;
  width: 1.875rem;
  height: 1.875rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid var(--tab-button-primary-color);
  background-color: var(--tab-button-secondary-color);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.08);
}`, "",{"version":3,"sources":["webpack://./src/_variables.scss","webpack://./src/components/Ide/Ide.module.scss"],"names":[],"mappings":"AAAA;;uBAAA;ACEA;EACC,yCAAA;EACA,YAAA;EACA,WAAA;EAEA,aAAA;EACA,kBAAA;EAGA,kBAAA;AADD;;AAIA;EACC,UAAA;EACA,4CAAA;EACA,WAAA;EACA,yBAAA;AADD;;AAIA;;EAAA;AAIA;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAFD;;AAKA;EACC,aAAA;EACA,8BAAA;EAEA,cAAA;EAEA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EAEA,iDAAA;EACA,qBAAA;AALD;;AAQA;EACC,eAAA;AALD;;AAQA;EACC,aAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,iDAAA;EACA,mDAAA;EACA,+CAAA;AAND","sourcesContent":["/***********************\n* GLOBAL COLOR TOKENS * \n***********************/\n$--neutral-00: #ffffff;\n$--neutral-50: #fafafa;\n$--neutral-100: #f4f4f5;\n$--neutral-200: #e4e4e7;\n$--neutral-300: #d4d4d8;\n$--neutral-400: #a1a1aa;\n$--neutral-500: #71717a;\n$--neutral-600: #52525b;\n$--neutral-700: #3f3f46;\n$--neutral-800: #27272a;\n$--neutral-900: #18181b;\n\n$--neutral-variant-00: #f8fafc;\n$--neutral-variant-50: #f1f5f9;\n$--neutral-variant-100: #e2e8f0;\n$--neutral-variant-200: #cbd5e1;\n$--neutral-variant-300: #b9c3d1;\n$--neutral-variant-400: #94a2b8;\n$--neutral-variant-500: #64738b;\n$--neutral-variant-600: #475569;\n$--neutral-variant-700: #334155;\n$--neutral-variant-800: #1e293b;\n$--neutral-variant-900: #0f172a;\n\n$--primary-00: #f7fbff;\n$--primary-50: #eff6ff;\n$--primary-100: #dbe9fe;\n$--primary-200: #bfdbfe;\n$--primary-300: #92c5fd;\n$--primary-400: #60a5fa;\n$--primary-500: #3c82f6;\n$--primary-600: #2463eb;\n$--primary-700: #1c4ed8;\n$--primary-800: #1d40ae;\n$--primary-900: #1f3a8a;\n\n$--secondary-00: #fcfffd;\n$--secondary-50: #ecfef6;\n$--secondary-100: #d1fae5;\n$--secondary-200: #a8f3d0;\n$--secondary-300: #6ee7b7;\n$--secondary-400: #34d399;\n$--secondary-500: #12b981;\n$--secondary-600: #079669;\n$--secondary-700: #047857;\n$--secondary-800: #076046;\n$--secondary-900: #064e3b;\n\n$--error-00: #fffdfd;\n$--error-50: #fef2f2;\n$--error-100: #fee2e1;\n$--error-200: #fecaca;\n$--error-300: #fda5a5;\n$--error-400: #f87171;\n$--error-500: #ef4444;\n$--error-600: #dc2625;\n$--error-700: #b91c1b;\n$--error-800: #991b1b;\n$--error-900: #7f1c1d;\n","@import \"../../variables\";\n\n.ideWrapper {\n\t/* Eat the remaining space on the page. */\n\tmin-width: 0;\n\twidth: 100%;\n\n\theight: 100vh;\n\tposition: relative;\n\n\t// Prevent resizeHandle z-index from escaping ideWrapper\n\tisolation: isolate;\n}\n\n.resizeHandle {\n\tz-index: 1;\n\theight: var(--console-log-resize-bar-height);\n\twidth: 100%;\n\tbackground-color: #{$--neutral-200};\n}\n\n/**\n * Header and tabs\n */\n\n.editorWrapper {\n\theight: 100%;\n\tflex: 1 0 0;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.editorHeader {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\tflex-shrink: 0;\n\n\tscrollbar-width: 0;\n\tdisplay: flex;\n\talign-items: center;\n\theight: var(--editor-header-height);\n\tgap: 0.125rem;\n\tmax-width: 100%;\n\toverflow-x: auto;\n\toverflow-y: hidden;\n\n\tbackground-color: var(--tab-button-primary-color);\n\tpadding-right: 0.5rem;\n}\n\n.icon {\n\theight: 1.25rem;\n}\n\nbutton.showMenuButton {\n\tdisplay: flex;\n\twidth: 1.875rem;\n\theight: 1.875rem;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\n\tborder-radius: 4px;\n\tborder: 1px solid var(--tab-button-primary-color);\n\tbackground-color: var(--tab-button-secondary-color);\n\tbox-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ideWrapper": `Ide-module__ideWrapper--fABC6`,
	"resizeHandle": `Ide-module__resizeHandle--lbGjf`,
	"editorWrapper": `Ide-module__editorWrapper--Eyeab`,
	"editorHeader": `Ide-module__editorHeader--Xu8mW`,
	"icon": `Ide-module__icon--odAa6`,
	"showMenuButton": `Ide-module__showMenuButton--bDW0p`
};
export default ___CSS_LOADER_EXPORT___;
